import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../Config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { where } from "firebase/firestore";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  TextField,
  MenuItem
} from "@mui/material";
import { collection, orderBy, query, getDocs } from "firebase/firestore";
import { db } from "../Config/firebase";
import { useHistory } from "react-router-dom";
import EnsaioRAAForm from "./EnsaioRAAForm";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import RelatorioRAAPrint from "./RelatorioRAAPrint";
import { tenantWhere , consultaTenantAtual} from "../Utils/tenant";

function separarCodigoRAA(valor) {
  const [base = "", ...complemento] = String(valor || "").split(".");
  return {
    base: Number(base),
    complemento: complemento.join("."),
  };
}

function adicionarDias(data, dias) {
  const resultado = new Date(data);
  resultado.setDate(resultado.getDate() + dias);
  return resultado;
}

function formatarDataISO(data) {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}

function normalizarDataISO(data) {
  if (!data) return "";
  const valor = String(data);
  if (valor.includes("/")) {
    const [dia, mes, ano] = valor.split("/");
    return `${ano}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
  }
  return valor;
}

function gerarDatasLeitura(dataMoldagem) {
  if (!dataMoldagem) return [];

  const [ano, mes, dia] = dataMoldagem.split("-").map(Number);
  if (!ano || !mes || !dia) return [];

  const dataBase = new Date(ano, mes - 1, dia);
  const leituraInicial = adicionarDias(dataBase, 1);
  const leituraDezesseisDias = adicionarDias(leituraInicial, 16);

  function proximasSegundasEQuintas(dataReferencia, quantidade, antesDe = null) {
    const datas = [];
    const cursor = adicionarDias(dataReferencia, 1);

    while (datas.length < quantidade) {
      if (antesDe && cursor >= antesDe) break;
      if (cursor.getDay() === 1 || cursor.getDay() === 4) {
        datas.push(new Date(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }

    return datas;
  }

  return [
    ...proximasSegundasEQuintas(leituraInicial, 4, leituraDezesseisDias),
    leituraDezesseisDias,
    ...proximasSegundasEQuintas(leituraDezesseisDias, 4),
  ].map(formatarDataISO);
}

function valorPreenchido(valor) {
  return valor !== null && valor !== undefined && String(valor).trim() !== "";
}

export default function ListaEnsaiosRAA() {

  const [ensaios, setEnsaios] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itensPerPage, setItensPerPage] = useState(20);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();
  const [modoEdicao, setModoEdicao] = useState(false);
  const [ensaioEditando, setEnsaioEditando] = useState(null);
  const [filtro, setFiltro] = useState("");
  const [filtroDebounce, setFiltroDebounce] = useState("");
  const [statusFiltro, setStatusFiltro] = useState("todos"); 
  const [obraSelecionada, setObraSelecionada] = useState(null);  
  const [totalEnsaios, setTotalEnsaios] = useState(0);
  const [modoPrint, setModoPrint] = useState(false);
  const [ensaioPrint, setEnsaioPrint] = useState(null);
  const [leiturasPrint, setLeiturasPrint] = useState([]);
  const [autoPrint, setAutoPrint] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [obrasUsuario, setObrasUsuario] = useState([]);

  const [ordenacao, setOrdenacao] = useState({
  campo: "codigo",
  direcao: "desc"
});


useEffect(() => {
  const unsub = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const snap = await getDoc(doc(db, "users", user.uid));

      if (snap.exists()) {
        const dados = snap.data();

        setUsuario(dados);
        setObrasUsuario(dados.obras || []);
      }
    }
  });

  return () => unsub();
}, []);

useEffect(() => {

  const timer = setTimeout(() => {
    setFiltroDebounce(filtro);
  }, 400);

  return () => clearTimeout(timer);

}, [filtro]);

useEffect(() => {
  setCurrentPage(0);
}, [filtroDebounce, statusFiltro, itensPerPage]);

useEffect(() => {

  if (!usuario) return;
  buscarTodosEnsaios();

}, [usuario]);



async function contarTotalEnsaios() {

  let q;

  if (usuario?.tipo === "cliente") {
    if (!obrasUsuario.length) {
      setTotalEnsaios(0);
      return;
    }
    q = query(
      collection(db, "tblEnsaioRAA"),
      ...tenantWhere(usuario),
      where("obraId", "in", obrasUsuario)
    );
  } else {
    q = query(collection(db, "tblEnsaioRAA"), ...tenantWhere(usuario));
  }

  const snap = await getDocs(consultaTenantAtual(q));
  const ativos = snap.docs.filter(doc => !doc.data().cancelado);
setTotalEnsaios(ativos.length);
}
useEffect(() => {
  if (usuario) {
    contarTotalEnsaios();
  }
}, [usuario]);
async function buscarTodosEnsaios() {

  setLoading(true);

  let q;

if (usuario?.tipo === "cliente") {
  if (!obrasUsuario.length) {
    setEnsaios([]);
    setLoading(false);
    return;
  }
  q = query(
    collection(db, "tblEnsaioRAA"),
    ...tenantWhere(usuario),
    where("obraId", "in", obrasUsuario),
  );
} else {
  q = query(
    collection(db, "tblEnsaioRAA"),
    ...tenantWhere(usuario)
  );
}

  const snap = await getDocs(consultaTenantAtual(q));

  const hoje = formatarDataISO(new Date());
  const inicioUltimos30Dias = new Date();
  inicioUltimos30Dias.setDate(inicioUltimos30Dias.getDate() - 29);
  const dataInicialPendencias = formatarDataISO(inicioUltimos30Dias);
  const lista = await Promise.all(snap.docs.map(async (documento) => {
    const dados = documento.data();
    const leiturasSnapshot = await getDocs(
      collection(db, "tblEnsaioRAA", documento.id, "leituras")
    );
    const leiturasSalvas = new Map(
      leiturasSnapshot.docs.map((leitura) => [leitura.id, leitura.data()])
    );
    const datasSugeridas = gerarDatasLeitura(dados.dataMoldagem);
    const datasPendentes = dados.cancelado === true
      ? []
      : datasSugeridas.map((dataSugerida, indiceLeitura) => {
        const leitura = leiturasSalvas.get(String(indiceLeitura));
        const dataLeitura = normalizarDataISO(leitura?.data || dataSugerida);
        return !valorPreenchido(leitura?.media) ? dataLeitura : "";
      }).filter((dataLeitura) =>
        dataLeitura >= dataInicialPendencias && dataLeitura <= hoje
      );
    const leituraHojePendente = datasPendentes.includes(hoje);
    const quantidadeLeiturasAtrasadas = datasPendentes.filter(
      (dataLeitura) => dataLeitura < hoje
    ).length;

    return {
      id: documento.id,
      ...dados,
      qtdLeituras: dados.qtdLeituras || 0,
      ultimaExp: dados.ultimaExp || null,
      leituraHojePendente,
      quantidadeLeiturasAtrasadas,
    };
  }));

  const filtrados =
  usuario && usuario.tipo === "cliente"
    ? lista.filter(e => obrasUsuario.includes(e.obraId))
    : lista;

setEnsaios(filtrados);

  setLoading(false);
}
 function ordenarPor(campo) {
  setOrdenacao(prev => ({
    campo,
    direcao:
      prev.campo === campo && prev.direcao === "asc"
        ? "desc"
        : "asc"
  }));
}   
      
  function editarEnsaio(ensaio) {
  setModoEdicao(true);
  setEnsaioEditando(ensaio);
  setOpenDialog(true);
}



  function abrirEnsaio(id) {

  // 🔒 CLIENTE NÃO FAZ NADA
  if (usuario?.tipo === "cliente") return;

  const ensaioSelecionado = ensaios.find(e => e.id === id);

  if (!ensaioSelecionado) return;

  const barraPadraoInicial = ensaioSelecionado.barraPadraoInicial;
  const barras = ensaioSelecionado.barras || [];

  const leituraInicialInvalida =
    !barraPadraoInicial ||
    barras.some(b => !b.micrometroInicial);

  if (leituraInicialInvalida) {
    alert("Você deve cadastrar as leituras iniciais antes de continuar...");
    return;
  }

  history.push(`/app/ensaio-raa/${id}`);
}

            async function imprimirEnsaio(e, opcoes = {}) {

  const { autoPrint: imprimirAutomaticamente = false } = opcoes;

  // 🔒 BLOQUEIO
  if (
    usuario?.tipo === "cliente" &&
    !obrasUsuario.includes(e.obraId)
  ) {
    alert("Você não tem permissão para imprimir este ensaio.");
    return;
  }

  try {

    const leiturasSnap = await getDocs(
      collection(db, "tblEnsaioRAA", e.id, "leituras")
    );

    const listaLeituras = leiturasSnap.docs.map(doc => {
      const l = doc.data();

      return {
        id: doc.id,
        dataLeitura: l.data,
        barra106: { expansao: l.barras?.[0]?.expansao },
        barra107: { expansao: l.barras?.[1]?.expansao },
        barra108: { expansao: l.barras?.[2]?.expansao },
        expansaoMedia:
          l.media !== ""
            ? Number(String(l.media).replace(",", "."))
            : null
      };
    });

    setEnsaioPrint(e);
    setLeiturasPrint(listaLeituras);
    setAutoPrint(imprimirAutomaticamente);
    setModoPrint(true);

  } catch (error) {
    console.error("Erro ao imprimir:", error);
    alert("Erro ao gerar impressão.");
  }
}


  function formatarDataBR(data) {
  if (!data) return "-";

  if (typeof data === "string" && data.includes("-")) {
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
  }

  if (data?.seconds) {
    const d = new Date(data.seconds * 1000);
    return d.toLocaleDateString("pt-BR");
  }

  return data;
}
const ensaiosFiltrados = ensaios.filter(e => {  
 
  const textoBusca = filtroDebounce.toLowerCase();

  const correspondeTexto =
  contemTextoPesquisa(String(e.codigo ?? "").toLowerCase(), textoBusca) ||
  contemTextoPesquisa(String(e.cliente ?? "").toLowerCase(), textoBusca) ||
  contemTextoPesquisa(String(e.obra ?? "").toLowerCase(), textoBusca) || // ✅ AQUI
  contemTextoPesquisa(String(e.fornecedor ?? "").toLowerCase(), textoBusca) ||
  contemTextoPesquisa(String(e.agregado ?? "").toLowerCase(), textoBusca) ||
  contemTextoPesquisa(String(e.cimento ?? "").toLowerCase(), textoBusca) ||
  contemTextoPesquisa(String(e.adicao ?? "").toLowerCase(), textoBusca);

      const valor = parseFloat(e.ultimaExp);
      const ehReativo = !isNaN(valor) && valor >= 0.19;
      const ehNaoReativo = !isNaN(valor) && valor < 0.19;
      const ehCancelado = e.cancelado === true;
      const ehConcluido = !ehCancelado && e.qtdLeituras >= 9;
      const ehEmAndamento = !ehCancelado && e.qtdLeituras < 9;
     

      let correspondeStatus = true;

      if (statusFiltro === "reativo") {
        correspondeStatus = ehReativo;
      }

      if (statusFiltro === "nao-reativo") {
        correspondeStatus = ehNaoReativo;
      }

      if (statusFiltro === "concluido") {
        correspondeStatus = ehConcluido;
      }
        if (statusFiltro === "andamento") {
          correspondeStatus = ehEmAndamento;
        }

        if (statusFiltro === "cancelado") {
          correspondeStatus = ehCancelado;
        }
  return correspondeTexto && correspondeStatus;
})
  const ensaiosOrdenados = ordenacao.campo
  ? [...ensaiosFiltrados].sort((a, b) => {

  const { campo, direcao } = ordenacao;

  let valorA = a[campo];
  let valorB = b[campo];

  if (campo === "codigo") {
    const codigoA = separarCodigoRAA(valorA);
    const codigoB = separarCodigoRAA(valorB);

    if (codigoA.base !== codigoB.base) {
      return direcao === "asc"
        ? codigoA.base - codigoB.base
        : codigoB.base - codigoA.base;
    }

    if (codigoA.complemento && !codigoB.complemento) {
      return direcao === "asc" ? 1 : -1;
    }
    if (!codigoA.complemento && codigoB.complemento) {
      return direcao === "asc" ? -1 : 1;
    }

    const comparacaoComplemento = codigoA.complemento.localeCompare(
      codigoB.complemento,
      "pt-BR",
      { numeric: true, sensitivity: "base" }
    );
    return direcao === "asc"
      ? comparacaoComplemento
      : -comparacaoComplemento;
  }

  // trata undefined/null
  if (!valorA) valorA = "";
  if (!valorB) valorB = "";

  // número
  if (campo === "qtdLeituras") {
    valorA = Number(valorA);
    valorB = Number(valorB);
  }

  // data
  if (campo === "dataMoldagem") {
    valorA = new Date(valorA);
    valorB = new Date(valorB);
  }

 if (valorA < valorB) return direcao === "asc" ? -1 : 1;
if (valorA > valorB) return direcao === "asc" ? 1 : -1;

// 🔹 desempate pelo código
const codA = separarCodigoRAA(a.codigo).base;
const codB = separarCodigoRAA(b.codigo).base;

if (codA < codB) return direcao === "asc" ? -1 : 1;
if (codA > codB) return direcao === "asc" ? 1 : -1;

return 0;
})
  : ensaiosFiltrados;

const inicio = currentPage * itensPerPage;
const fim = inicio + itensPerPage;

const ensaiosPaginados = ensaiosOrdenados.slice(inicio, fim);

useEffect(() => {

  function handleAfterPrint() {
    setModoPrint(false);
    setEnsaioPrint(null);
    setLeiturasPrint([]);
    setAutoPrint(false);
  }

  window.addEventListener("afterprint", handleAfterPrint);

  return () => {
    window.removeEventListener("afterprint", handleAfterPrint);
  };

}, []);
          if (modoPrint && ensaioPrint) {
            return (
              <RelatorioRAAPrint
                ensaio={ensaioPrint}
                leituras={leiturasPrint}
                autoPrint={autoPrint}
                onVoltar={() => {
                  setModoPrint(false);
                  setAutoPrint(false);
                }}
              />
            );
          }

function renderIcon(campo) {
  if (ordenacao.campo !== campo) return null;

  return ordenacao.direcao === "asc"
    ? <ArrowUpwardIcon sx={{ fontSize: 16, ml: 0.5 }} />
    : <ArrowDownwardIcon sx={{ fontSize: 16, ml: 0.5 }} />;
}

  return (
  <>
    <Navbar />

    <Box sx={{ p: 4 }}>
      <Paper className="cabecalho-lista-cadastro" elevation={0}>
      <Typography variant="h6" fontWeight={700}>Ensaios RAA</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>Lista de Ensaios Cadastrados</Typography>
      <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            mb={3}
          >

            {/* 🔹 BOTÃO ESQUERDA */}
            {usuario?.tipo !== "cliente" && (
  <Button
    variant="contained"
    onClick={() => {
      setModoEdicao(false);
      setEnsaioEditando(null);

      setObraSelecionada({
        id: "",
        nome: "",
        clienteNome: ""
      });

      setOpenDialog(true);
    }}
  >
    + Novo Ensaio
  </Button>
)}

            {/* 🔹 PESQUISAR OCUPANDO ESPAÇO */}
            <TextField
  size="small"
  label="Pesquisar"
  placeholder="Código, Cliente, Obra, Agregado, Cimento ou Adição"
  value={filtro}
  onChange={(e) => setFiltro(e.target.value)}
  sx={{ flex: 1 }}
/>

<TextField
  size="small"
  label="Qtd Ensaios"
  value={ensaiosFiltrados.filter(e => !e.cancelado).length}
  InputProps={{
    readOnly: true
  }}
  sx={{ width: 140 }}
/>
            {/* 🔹 STATUS NA DIREITA */}
            <TextField
              select
              size="small"
              label="Status"
              value={statusFiltro}
              onChange={(e) => setStatusFiltro(e.target.value)}
              sx={{ width: 180 }}
            >
              <MenuItem value="todos">Todos</MenuItem>
              <MenuItem value="nao-reativo">Não Reativo</MenuItem>
              <MenuItem value="reativo">Reativo</MenuItem>
              <MenuItem value="concluido">Concluído</MenuItem>
              <MenuItem value="andamento">Em andamento</MenuItem>
              <MenuItem value="cancelado">Cancelados</MenuItem>
            </TextField>

          </Stack> 
      </Paper>

      <Paper
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  border: "1px solid #e2e8f0",
                  boxShadow: "none"
                }}
              >
        <Table className="lista-cadastro-padrao" size="small" sx={{ minWidth: 900 }}>
          <TableHead
                sx={{
                  backgroundColor: "#f8fafc"
                }}
              >
              <TableRow>
                

                <TableCell onClick={() => ordenarPor("codigo")} sx={{ cursor: "pointer" }}>
                  <Box display="flex" alignItems="center">
                    <strong>Cód. RAA</strong>
                    {renderIcon("codigo")}
                  </Box>
                </TableCell>


              <TableCell onClick={() => ordenarPor("cliente")} sx={{ cursor: "pointer" }}>
                  <Box display="flex" alignItems="center">
                    Cliente / Obra
                    {renderIcon("cliente")}
                  </Box>
                </TableCell>

              <TableCell onClick={() => ordenarPor("dataMoldagem")} sx={{ cursor: "pointer" }}>
                  <Box display="flex" alignItems="center">
                    Data
                    {renderIcon("dataMoldagem")}
                  </Box>
                </TableCell>
                <TableCell
  sx={{
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#64748b",
    fontWeight: 600,
    borderBottom: "1px solid #e2e8f0"
  }}
>
                      Materiais
                    </TableCell>
                <TableCell
  sx={{
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#64748b",
    fontWeight: 600,
    borderBottom: "1px solid #e2e8f0"
  }}
>
                <strong>Leituras</strong>
              </TableCell>
              <TableCell align="center"><strong>Status</strong></TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>

             <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}>
                      <CircularProgress />
                      <Typography color="text.secondary">Carregando registros...</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {ensaiosPaginados.map(e => (
                <TableRow
  key={e.id}
  hover
  sx={{
    height: 48,
    transition: "background 0.2s",
    "&:hover": {
      backgroundColor: "#f8fafc"
    }
  }}
>

                    {/* 🔹 CÓDIGO RAA */}
                    <TableCell
                        align="center"
                        onClick={() => abrirEnsaio(e.id)}
                          sx={{
                            cursor: usuario?.tipo === "cliente" ? "default" : "pointer"
                          }}
                      >
                      {e.codigo || "-"}
                    </TableCell>

                    <TableCell onClick={() => abrirEnsaio(e.id)} sx={{ cursor: "pointer" }}>
                      <div className="lista-dado-principal">{e.cliente || "-"}</div>
                      <div className="lista-dado-secundario">Obra: {e.obra || "-"}</div>
                    </TableCell>

                    <TableCell
                            className="lista-dado-secundario"
                            onClick={() => abrirEnsaio(e.id)}
                            sx={{ cursor: "pointer" }}
                          >
                            <Box>
                              <Typography variant="caption">
                                <span className="lista-dado-destaque">Moldagem:</span>{" "}
                                <span className="lista-dado-secundario">{formatarDataBR(e.dataMoldagem)}</span>
                              </Typography>

                              {e.dataPrevistaTermino && (
                                <Typography variant="body2">
                                  <span className="lista-dado-destaque">Prev. Término:</span>{" "}
                                  <span className="lista-dado-secundario">{formatarDataBR(e.dataPrevistaTermino)}</span>
                                </Typography>
                              )}

                              {e.dataTermino && (
                                <Typography
                                  variant="body2"
                                  sx={{ color: "green", fontWeight: 600 }}
                                >
                                  Terminado em: {formatarDataBR(e.dataTermino)}
                                </Typography>
                              )}
                            </Box>
                          </TableCell>

                    {/* 🔹 MATERIAIS */}
                      <TableCell
                        onClick={() => abrirEnsaio(e.id)}
                        sx={{ cursor: "pointer" }}
                      >
                        <Box>
                          <Typography variant="body2">
                          <span className="lista-dado-destaque">Agregado:</span>{" "}
                          <span className="lista-dado-secundario">
                            {e.agregado || "-"} {e.fornecedor ? `${e.fornecedor} - ` : ""}
                          </span>
                        </Typography>

                          <Typography variant="body2" className="lista-dado-secundario">
                            {e.cimento || "-"}
                          </Typography>

                          {e.adicao && e.adicao.trim() !== "" && (
                            <Typography variant="body2">
                              <span className="lista-dado-destaque">Adição:</span>{" "}
                              <span className="lista-dado-secundario">{e.adicao}</span>
                            </Typography>
                          )}
                        </Box>
                      </TableCell>

                     {/* 🔹 LEITURAS */}
<TableCell
  className="lista-dado-secundario"
  align="center"
  onClick={() => abrirEnsaio(e.id)}
  sx={{ cursor: "pointer" }}
>
  {e.qtdLeituras > 0 ? (
    <Box>
      <Typography variant="body2">
        <strong>{e.qtdLeituras}</strong> leituras
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color:
            parseFloat(e.ultimaExp) >= 0.19
              ? "error.main"
              : "success.main"
        }}
      >
        Última: {e.ultimaExp} %
      </Typography>
    </Box>
  ) : (
    <Typography variant="body2" color="text.secondary">
      0 leituras
    </Typography>
  )}

  {e.leituraHojePendente && (
    <Typography
      variant="body2"
      sx={{
        display: "inline-block",
        mt: 0.5,
        px: 0.75,
        py: 0.15,
        borderRadius: 0.75,
        border: "1px solid #ffe08a",
        bgcolor: "#fff3cd",
        color: "#8a6500",
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      Leitura hoje
    </Typography>
  )}

  {usuario?.tipo !== "cliente" && e.quantidadeLeiturasAtrasadas > 0 && (
    <Typography
      variant="body2"
      sx={{
        display: "inline-block",
        mt: 0.5,
        px: 0.75,
        py: 0.15,
        borderRadius: 0.75,
        border: "1px solid #ffe08a",
        bgcolor: "#fff3cd",
        color: "#8a6500",
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      {e.quantidadeLeiturasAtrasadas}{" "}
      {e.quantidadeLeiturasAtrasadas === 1 ? "leitura atrasada" : "leituras atrasadas"}
    </Typography>
  )}
</TableCell>

        {/* 🔹 STATUS */}
        <TableCell
  align="center"
  sx={{ fontWeight: 600 }}>
          {(() => {

  // 🔴 PRIORIDADE MÁXIMA
  if (e.cancelado) {
    return (
      <Typography
        variant="body2"
        sx={{ fontWeight: 700, color: "error.main" }}
      >
        Cancelado
      </Typography>
    );
  }

  if (e.qtdLeituras >= 9) {
              return (
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Concluído
                </Typography>
              );
            }

            if (e.qtdLeituras < 9) {
             return (
              <Typography
                variant="body2"
                sx={{ fontWeight: 700, color: "warning.main" }}
              >
                Em andamento
              </Typography>
            );
          }

            const valor = parseFloat(e.ultimaExp);
            const reativo = !isNaN(valor) && valor >= 0.19;

            return (
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  color: reativo ? "error.main" : "success.main"
                }}
              >
                {reativo ? "Reativo" : "Não Reativo"}
              </Typography>
            );

          })()}
        </TableCell>


              {/* 🔹 AÇÕES */}
              <TableCell align="center">
                          <Box display="flex" justifyContent="center" gap={1}>
                            
                            <Box display="flex" justifyContent="center" gap={1}>

                          <Tooltip title="Visualizar">
                            <IconButton
                              size="small"
                              onClick={(event) => {
                                event.stopPropagation();
                                imprimirEnsaio(e, { autoPrint: false });
                              }}
                            >
                              <VisibilityIcon sx={{ color: "primary.main" }} />
                            </IconButton>
                          </Tooltip>

                          {usuario?.tipo !== "cliente" && (
                            <Tooltip title="Editar">
                              <IconButton
                                size="small"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  editarEnsaio(e);
                                }}
                              >
                                <EditIcon sx={{ color: "#0288d1" }} />
                              </IconButton>
                            </Tooltip>
                          )}
                          <HistoricoCadastro colecao="tblEnsaioRAA" documentoId={e.id} registro={e} />

                        </Box>                          

                          </Box>
                        </TableCell>

                  </TableRow>
              ))}
              {!loading && ensaiosPaginados.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Nenhum ensaio cadastrado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
        </Table>
      </Paper>
      <Stack direction="row" justifyContent="space-between" mt={2}>

  <TextField
    select
    size="small"
    label="Itens"
    value={itensPerPage}
    onChange={(e) => {
      setItensPerPage(Number(e.target.value));
      setCurrentPage(0);
      setCursors({});
    }}
    sx={{ width: 120 }}
  >
    <MenuItem value={10}>10</MenuItem>
    <MenuItem value={20}>20</MenuItem>
    <MenuItem value={50}>50</MenuItem>
  </TextField>

  <Stack direction="row" spacing={1}>

    <Button
        disabled={currentPage === 0}
        onClick={() => setCurrentPage(p => p - 1)}
      >
        Anterior
      </Button>

    <Typography sx={{ display: "flex", alignItems: "center" }}>
      Página {currentPage + 1}
    </Typography>

    <Button
  disabled={fim >= ensaiosOrdenados.length}
  onClick={() => setCurrentPage(p => p + 1)}
>
  Próxima
</Button>

  </Stack>

</Stack>

      <EnsaioRAAForm
        open={openDialog}
        modoEdicao={modoEdicao}
        ensaioEditando={ensaioEditando}
        obraSelecionada={obraSelecionada}   // ✅ AQUI
        onClose={(salvou) => {

  setOpenDialog(false);
  setModoEdicao(false);
  setEnsaioEditando(null);

  if (salvou) {
    buscarTodosEnsaios();
  }

}}
        />
    </Box>
  </>
);
}

